
import { defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";
import IInput from "@/components/input/IInput.vue";
import Message from "@/components/message/Message.vue";
import SubmitButton from "@/components/submit-button/SubmitButton.vue";
import { LoginFields } from "@/modules/login/components/forms/login/login-models";
import { SystemMode, productName } from "@/models/system-mode";

export default defineComponent({
  name: "LoginForm",
  components: {
    IInput,
    Message,
    SubmitButton,
  },
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  props: {
    systemMode: {
      type: String as PropType<SystemMode>,
      required: true,
      default: SystemMode.firstread,
    },
    errorMessage: {
      type: String,
    },
  },
  emits: {
    login(loginFields: LoginFields): boolean {
      return loginFields.userName !== "" && loginFields.password !== "";
    },
  },
  data() {
    return {
      formFields: {
        userName: "",
        password: "",
      } as LoginFields,
    };
  },
  computed: {
    loginText(): string {
      return this.t("login.product", { product: productName[this.systemMode] });
    },
    isValid(): boolean {
      return this.errorMessage ? false : true;
    },
    isSubmissionValid() {
      if (this.isValid) {
        return true;
      }
      return false;
    },
  },
  methods: {
    submitLoginForm(): void {
      this.$emit("login", {
        ...this.formFields,
      });
    },
  },
});
